module.exports = __webpack_public_path__ + "static/Gapsi3-21642c0268ec59ac697eccd29d06d1c5.png";